<table class="table table-hover table-dark">
  <thead>
    <tr>
      <th scope="col"><i class="fas fa-calendar-alt"></i> Date</th>
      <th scope="col">daily_cases</th>
      <th scope="col">daily_recovered</th>
      <th scope="col">daily_deaths</th>
      <th scope="col">total_cases</th>

    </tr>
  </thead>
  <tbody  *ngFor="let i of [39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,
  61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87]">
    <tr *ngFor="let cases of caseees">
      <th scope="row">{{cases[i].Date | date: 'd MMMM y'}}</th>
      <td style="color: black;">{{ cases[i].Confirmed - cases[i-1].Confirmed | number :"1.0" }}</td>
      <td style="color: green;">{{ cases[i].Recovered - cases[i-1].Recovered | number :"1.0" }}</td>
      <td style="color: red;">{{ cases[i].Deaths - cases[i-1].Deaths | number :"1.0" }}</td>
      <td >{{ cases[i].Confirmed | number :"1.0"}}</td>

    </tr>


  </tbody>
</table>
